<template>
  <div
    :class="[
      'heading',
      {
        'sub': sub,
        'detail': detail
      }
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ProaHeading',
  props: {
    sub: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.heading {
  color: black;
  font-size: 20px;
  font-weight: 700;
  word-break: keep-all;

  &.sub {
    font-size: 15px;
    font-weight: 600;
  }

  &.detail {
    font-size: 14px;
    font-weight: 600;
    color: $secondary-color !important;
  }

  @include mq(md) {
    font-size: 24px;

    &.sub {
      font-size: 18px;
    }

    &.detail {
      font-size: 16px;
    }
  }
}
</style>
